import SelectTable from '../../../generic/selectTable';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import {STATUS_DRAFT, STEP_1, TableSelectOption} from '../../../../redux/slices/LomavisPostApproval/constants';
import { setApprovalKey } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { formatUsers } from './utils';
import {lomavisShowToastr} from "../../../../redux/slices/utils/ui/toastr";
import {TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED} from "../../../lomavisCreator/config/constants";

interface UserSelectTableProps {
  currentStep?: Number;
}

const UserSelectTable = ({ currentStep }: UserSelectTableProps) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const {
    data: {
      approval_step_2_users,
      approval_step_1_users,
      users,
      location_uuid,
      cloud_uuid,
      is_multipost,
      status
    }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const onSelect = (user: any): void => {
    if (status > STATUS_DRAFT) {
      lomavisShowToastr(
        t(TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED),
        'error'
      );
      return;
    }

    let selected = approval_step_1_users;
    let key = 'approval_step_1_users';

    if (currentStep !== STEP_1) {
      selected = approval_step_2_users;
      key = 'approval_step_2_users';
    }

    const normalizedSelected = selected.map((u) => (TableSelectOption.USER in u ? u.user : u));

    let newSelectedUsers = [];
    if (normalizedSelected.some((u) => u.uuid === user.uuid)) {
      newSelectedUsers = selected.filter(
        (u) => ('user' in u ? u.user.uuid : u.uuid) !== user.uuid
      );
    } else {
      newSelectedUsers = [...selected, user];
    }
    dispatch(setApprovalKey({ key, value: newSelectedUsers }));
  };

  return (
    <SelectTable
      data={formatUsers(users, {
        location_uuid,
        cloud_uuid,
        is_multipost
      })}
      onSelect={onSelect}
      selected={(currentStep === STEP_1
        ? approval_step_1_users
        : approval_step_2_users
      ).map((user) => ('user' in user ? { ...user.user } : user))}
      canEdit={false}
      onEdit={() => {}}
    />
  );
};

export default UserSelectTable;
